import { render } from "./Robot.vue?vue&type=template&id=1ce74fa6&scoped=true"
import script from "./Robot.vue?vue&type=script&lang=js"
export * from "./Robot.vue?vue&type=script&lang=js"

import "./Robot.vue?vue&type=style&index=0&id=1ce74fa6&scoped=true&lang=css"
import "./Robot.vue?vue&type=style&index=1&id=1ce74fa6&scoped=true&lang=css"

import exportComponent from "D:\\vue\\rs459\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce74fa6"]])

export default __exports__